export default __webpack_public_path__ + "static/quote-bg-2-min-43ccd1f0a43569464c61be4640a117b0.png";